<template>
  <div>
    <div class="message-box">
      <s-card :border="true" :padding="false" class="flex-grow pl-64 container pr-0">
        <div class="flex items-center content-center height-100 relative">
          <input class="border-less-input width-100 font-14 p-8"
                 placeholder="Type your message here"
                 v-on:focus="onInputFocus"
                 v-on:blur="onInputBlur"
                 @input="handleInput"
                 v-bind:value="value"
                 ref="messageField"
                 @keydown="onInputKeyPress"
          />
          <s-button
              :dropdown="false"
              title=""
              @clicked-item="attachmentClicked"
              icon="attachment.png"
              :outline="false"
              :borderL="true"
          ></s-button>
          <s-button
              :dropdown="false"
              title=""
              @clicked-item="sendMessage"
              :icon-opacity="inputFocused ? 1 : 0.3"
              icon="send.png"
              :outline="false"
              :borderL="true"
          ></s-button>

          <div class="absolute mention-box-wrapper" v-if="mentionCheck" v-click-outside-el="onOutsideClick">
            <div  class="pt-16 pb-16 bg-white dropdown-content">
              <s-scroll-view max-height="">
                <ul>
                  <li v-for="(user,index) of $options.filters.searchFilter(assignedUsers, search)" :key="index"  v-on:click="()=>{selectMentionUser(user)}">{{user | fullName}}</li>
<!--                  <li v-if="assignedUsers.length===0">No User available</li>-->
                </ul>
              </s-scroll-view>
            </div>
          </div>
        </div>
      </s-card>
    </div>
    <div class="pl-64">
      <s-badge

          v-for="(tag,index) of tags" :key="index"

          :label="tag"
          :background="'#8ca178'"
          :color="'#fff'"
          :badgeSlot="'start'"
          class="quote-status"
          :removable="true"
          @remove="()=>{removeTaggedUser(index)}"
      ></s-badge>
    </div>
    <input type="file" :ref="'attachmentFile'" @change="handleAttachmentFile()" hidden />

    <div>
      <s-card v-if="attachments.length>0" :border="true" :padding="true" class="pl-64 pr-16">
        <div class="file-boxes-grid">
          <s-file-box v-for="(attachment,index) of attachments" :key="index"
                      :src="attachment.src" :viewable="attachment.viewable"
                      :file-size="attachment.fileSize"
                      :file-name="attachment.fileName"
                      :icon="attachment.icon"
                      @on-remove="()=>{removeAttachment(index);}"

          />
        </div>
      </s-card>
    </div>
  </div>
</template>

<script>
import SButton from "./SButton";
import SCard from "./SCard";
import SFileBox from "./SFileBox";
import SScrollView from "./SScrollView";
import SBadge from "./SBadge";

export default {
  name: "MessageBox",
  components:{
    SScrollView,
    SFileBox,
    SButton,
    SCard,
    SBadge
  },
  props: {
    value: {},
    setFocus:{default: false},
    wallUsers: {},
  },
  data: function (){
    return {
      inputFocused: false,
      attachments:[],
      search:'',
      mentionCheck: false,
      assignedUsers:this.wallUsers ? this.wallUsers : [],
      tags:[],
      taggedUsers:[],
    }
  },
  methods: {
    attachmentClicked(){
      this.$refs.attachmentFile.click();
    },
    handleInput: function (event) {
      this.$emit("input", event.target.value);
    },
    onInputFocus(){
      this.inputFocused = true;
      this.$emit('focus-change',true);
    },
    onInputBlur(){
      this.inputFocused = false;
      this.$emit('focus-change',false);
    },
    sendMessage(){
      //create message object
      if(!this.value){
         this.$toast.warning('Please write message before sending!',{
          	timeOut: 3000
        });
        return;
      }
      let msgObject = {
        messageBody:this.value,
        users:this.taggedUsers,
        attachmentFileData: this.attachments,//just to upload in parent components
      };

      this.$emit('send-message',msgObject);
    },

    removeAttachment(index){
      this.attachments.splice(index,1);
    },

    setFocusToMessageField(){
      this.$refs.messageField.focus();
    },

    handleAttachmentFile: function() {
      if(this.$refs.attachmentFile.files[0]){
        console.log(this.$refs.attachmentFile.files[0]);
        this.buildFilesArray(this.$refs.attachmentFile.files[0]);
        // this.comment.attachmentFile.push(this.$refs.attachmentFile.files[0]);
      }
    },
    buildFilesArray(file){
      this.attachments.push(
          {
            fileName: file.name,
            src: URL.createObjectURL(file),
            originalName: file.name,
            file: file,
            viewable: this.isImageFile(file.name),
            icon: this.getFileIcon(file.name),
          }
      );
    },

    isImageFile(fileName){
      let fileArray = ['.png','.jpeg','.jpg','.gif','.bmp', '.webp']
      if(fileName){
        for(let type of fileArray){
          if(fileName.toLowerCase().includes(type)){
            return true;
          }
        }
      }
      return false;
    },
    getFileIcon(fileName){
      if(fileName){
        let extension = fileName.split('.').pop();
        if(['doc','docx','xlsx','xlx','pdf'].includes(extension)){
          return extension+'.png';
        }
      }
      return 'file-icon.png';
    },

    onInputKeyPress(event){
      let pressedKey = event.keyCode;
      if(event.key === 'Shift' || event.ctrlKey){
        // just shift or control, ignore. if not ignored, then user list disappears on shift or control
        return;
      }
      if(event.key === 'Backspace'  && this.search && this.search.length > 0){
        // it is backspace, so remove one character from string
        this.search=this.search.substr(0,this.search.length-1);
        return;
      }
      if(this.mentionCheck === true && !['Backspace','Alt','ArrowDown','ArrowUp','ArrowLeft','ArrowRight','NumLock'].includes(event.key)){
        // if mentionCheck equals true and if backspace is not being pressed.
        this.search = this.search + event.key;
      }
      if(this.mentionCheck && ['ArrowDown','ArrowUp'].includes(event.key)){
        event.preventDefault();
      }
      if(event.key === '@'){
        // this.replyForm[index].showing = true;
        //now check if there is space or start of input before @
        let caretPosition = event.target.selectionStart;
        console.log('caretPosition',caretPosition);
        //there must be space or it should be first letter to start mentioning
        if(caretPosition===0 || this.value.charAt(caretPosition-1)===' '){
          this.mentionCheck = true;
          this.search = "";
        }

      }
      if(event.key==='Escape'){
        this.mentionCheck = false;
        this.search = "";
      }
    },
    onOutsideClick(){
      this.mentionCheck = false;
      this.search = "";
    },

    selectMentionUser(value){
      if(value.invalid){
        return;
      }
      this.tags.push(value.firstName + ' ' + value.lastName);
      this.addTaggedUser(value.username, value.firstName, value.lastName, value.email);
      let tempValue=this.value.replace('@' + this.search, ' ');
        this.$emit('input',tempValue);

      // if(this.value.charAt(0)==='@'){
      //   let tempValue = this.value.replace('@'+this.search,' @'+this.fullName(value));
      //   this.$emit('input',tempValue);
      // }
      // else {
      //   let tempValue = this.value.replace(' @'+this.search,' @'+this.fullName(value));
      //   this.$emit('input',tempValue);
      // }
      this.search="";
      this.mentionCheck = false;

    },
    fullName: function (data) {
      if (data) {
        return data.firstName + (data.lastName ? (' ' + data.lastName) : '');
      }
      return '';
    },

    addTaggedUser: function(username, firstName, lastName, email) {
      this.taggedUsers.push({
        'username': username,
        'firstName': firstName,
        'lastName': lastName,
        'email': email
      });
    },
    removeTaggedUser(index) {
      console.log(index);
      this.tags.splice(index,1);
      this.taggedUsers.splice(index,1);
    },

    clearMessageBox(){
      this.tags = [];
      this.taggedUsers = [];
      this.attachments =[];
      this.$emit('input','');
    }
  },


  filters: {
    searchFilter: function(users, search){
      search = search.replace(/@/g,'');
      if(!search) {
        return users;
      }
      let solution = users.filter(v => {
        if(!v) {
          return;
        }
        var name = v.firstName +' '+ v.lastName;
        return name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
      })
      // for showing 'No Users' message
      if(solution.length === 0){
        let empty = [{firstName: 'No User available',invalid:true}];
        return empty;
      }
      else{
        return solution;
      }
    }
  }
}

</script>

<style scoped lang="scss">


.flex-grow{
  flex-grow: 1;
  align-self: stretch;
}

.message-box {
  height: 57px !important;
  display: flex;
  padding-bottom: 2px;
}

.container {
  height: 100%;
  width: 100%;
}

.flex {
  display: flex;
  flex: 1;
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}
.content-stretch {
  align-content: stretch;
}
.content-center {
  align-content: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.items-center {
  align-items: center;
}

.width-100{
  width: 100%;
}
.height-100{
  height: 100%;
}
.font-14{
  font-size: 16px;
}

.no-resize {
  resize: none;
}

.pb-16 {
  padding-bottom: 16px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pr-12 {
  padding-right:12px;
}
.p-8{
  padding: 8px;
}
.pr-0{
  padding-right:0;
}

.p-12 {
  padding: 18px;
}
.pl-64{
  padding-left: 64px;
}

.pl-64{
  padding-left: 64px;
}

.border-less-input, .border-less-input:hover, .border-less-input:focus, .border-less-input:active {
  background: transparent;
  //border: 1px solid black;
  border: 0 none transparent;
  outline: none;
  outline-offset: 0;
  box-shadow: none;
}

.file-boxes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 20px;
}

.mention-box-wrapper {
  position: absolute;
  bottom:60px;
  left:10px;
  z-index: 5;
}

.dropdown-content {
  background-color: #ffffff;
  box-shadow: 0 0 11px 0 #e1e1e1;
  text-align: start;
  margin-top: 2px;
}

.dropdown-content li {
  list-style: none;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom:8px;
  padding-top:8px;
}

.dropdown-content li:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}


ul {
  padding:0px;
  margin: 0px;
}
</style>